import React from "react";
import {TableCell, TableRow, Typography} from "@mui/material";

export interface TableColumnData<R> {
    key: string;
    header: string;
    width?: string;
    align?: 'left' | 'right' | 'center';
    cell: (row: R, rowIndex: number) => React.ReactNode | undefined;
}

export function TableHeaderRow({children}: {
    children: React.ReactNode,
}) {
    return (
        <TableRow sx={{backgroundColor: 'background.paper'}}>
            {children}
        </TableRow>
    );
}

export function TableHeaderCell<R>({column}: { column: TableColumnData<R> }) {
    return (
        <TableCell
            variant="head"
            sx={{width: column.width, textAlign: column.align}}
        ><Typography variant="button">{column.header}</Typography></TableCell>
    );
}

export function createFixedHeaderContent<R>(columns: TableColumnData<R>[]) {
    return (
        <TableHeaderRow>
            {columns.map(column => (
                <TableHeaderCell key={column.key} column={column} />
            ))}
        </TableHeaderRow>
    );
}
